// extracted by mini-css-extract-plugin
module.exports = {"debug":"video_debug__MxsyR","videoContainer":"video_videoContainer__ozrov","videoFrame":"video_videoFrame__10cf1"};